// services/settings.js
import api from './api';

export const getSystemSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

export const updateSystemSettings = async (settings) => {
  const response = await api.post('/settings', settings);
  return response.data;
};

export const testDiscordWebhook = async (webhookUrl) => {
  const response = await api.post('/settings/test-discord-webhook', {
    discord_webhook: webhookUrl
  });
  return response.data;
};